<!--<b>GOODWILL</b><br/>-->
<!--<p>-->
<!--    Goodwill is de meerwaarde van een onderneming boven de balanswaarde. Het vertegenwoordigt toekomstige inkomsten van-->
<!--    de onderneming die nog niet zijn gewaardeerd op de balans, maar die al wel bestaan. Voorbeelden hiervan zijn-->
<!--    klantenkring, naamsbekendheid en personeel. Goodwill die je overneemt, vormt een bedrijfsmiddel waarop kan worden-->
<!--    afgeschreven. Het afschrijvingspercentage op goodwill is maximaal 10%.-->
<!--    <br/><br/>-->
<!--    Vermeld hier niet de goodwill die is meegekocht bij de aankoop van deelnemingen. Op die goodwill kun je niet-->
<!--    afschrijven.-->
<!--</p>-->
<!--<br/>-->
<!--<b>OVERIG IMMATERIELE VASTE ACTIVA</b>-->
<!--<p>Onder 'Overig immateriële vaste activa' vallen bijvoorbeeld:</p>-->
<!--<ul>-->
<!--    <li>Notariële kosten en andere oprichtings- en emissiekosten.<br>-->
<!--        Notariële kosten en andere oprichtings- en emissiekosten zijn bijvoorbeeld notariskosten voor de oprichtingsakte-->
<!--        en kosten die u maakt bij het uitgeven van nieuwe aandelen (emissiekosten).-->
<!--    </li>-->
<!--    <li>Kosten van onderzoek en ontwikkeling.<br>-->
<!--        Je kunt kosten van onderzoek en ontwikkeling alleen activeren en vervolgens afschrijven, als het gaat om het-->
<!--        ontwikkelen van concrete technologieën en producten.-->
<!--    </li>-->
<!--    <li>Vergunningen, concessies en intellectuele eigendommen.</li>-->
<!--    <li>Vooruitbetaling op immateriële vaste activa.</li>-->
<!--    <li>Productierechten (voor agrariërs).</li>-->
<!--</ul>-->

<!--<b>Vergunningen, concessies en intellectuele eigendommen</b>-->
<!--<p>Voorbeelden van vergunningen en concessies zijn:</p>-->
<!--<ul>-->
<!--    <li>Vervoersvergunningen</li>-->
<!--    <li>Vangstquota</li>-->
<!--    <li>Octrooien</li>-->
<!--    <li>Patenten</li>-->
<!--    <li>Auteursrechten</li>-->
<!--</ul>-->
<!--<p>Vergunningen, concessies en intellectuele eigendommen moeten worden geboekt voor de kostprijs of voor een lagere-->
<!--    bedrijfswaarde. De uitgaven voor vergunningen, concessies en dergelijke moet je door afschrijving toerekenen aan de-->
<!--    jaren waarin ze zullen worden benut. Bij de afschrijving moet je rekening houden met de restwaarde. Als je voor de-->
<!--    instandhouding van de vergunningen, concessies en intellectuele eigendommen periodiek, bijvoorbeeld jaarlijks,-->
<!--    betalingen moet doen, dan mag je deze in het jaar van betaling ineens ten laste van de winst brengen.</p>-->

<!--<b>Productierechten voor agrariërs</b>-->
<!--<p>Productierechten zijn verhandelbare rechten voor landbouwers om te mogen produceren. De productierechten zijn meestal-->
<!--    gebaseerd op een uitwerking van het landbouwbeleid van de Europese Unie. Je kunt de kosten van productierechten-->
<!--    afschrijven volgens de daarvoor afgesproken regelingen. Zie <a-->
<!--            href="https://www.belastingdienst.nl/data/online_aangifte/vpb/vpb2023/meer_info/afschrijving_productierechten.htm"-->
<!--            target="_blank">Afschrijving productierechten</a> voor meer informatie hierover.</p>-->

<!--<br/>-->
<!--<b>GEBOUWEN EN TERREINEN</b>-->
<!--<p>Voor het bepalen van de fiscale winst is de normale jaarlijkse afschrijving op gebouwen beperkt. Deze-->
<!--    beperking houdt in dat de boekwaarde van een gebouw niet lager mag zijn dan de bodemwaarde. Het begrip bodemwaarde-->
<!--    is een fiscaal begrip. Het heeft niets te maken met de waarde van de grond. Het is ook niet-->
<!--    hetzelfde als de restwaarde. Voor alle bedrijfsgebouwen geldt een bodemwaarde van 100% van de WOZ-waarde.</p>-->
<!--<b>Milieubedrijfsmiddelen en bodemwaarde</b>-->
<!--<p>De boekwaarde van een gebouw dat een milieubedrijfsmiddel is en dat u op of na 1 januari 2009 hebt gekocht, mag lager-->
<!--    zijn dan de bodemwaarde. Als je in het kalenderjaar 2007 of 2008 onroerende zaken hebt aangeschaft die een-->
<!--    milieubedrijfsmiddel zijn, moet je-->
<!--    (ook in latere jaren) rekening blijven houden met de bodemwaarde.</p>-->
<!--<b>Bedrijfsterreinen</b>-->
<!--<p>Omdat grond en (bedrijfs)terreinen niet slijten, kun je daarop niet afschrijven. Wel kun je afschrijven op-->
<!--    verbeteringen aan de (bedrijfs)terreinen zoals erfverhardingen, drainage, damwanden e.d.</p>-->

<!--<br/>-->
<!--<b>ANDERE VASTE ACTIVA </b>-->
<!--<p>Onder 'Andere materiële vaste activa' vallen bijvoorbeeld:</p>-->
<!--<ul>-->
<!--    <li>inventaris.</li>-->
<!--    <li>auto's en overige transportmiddelen.</li>-->
<!--    <li>vooruitbetaling op materiële vaste activa.</li>-->
<!--    <li>agrarische materiële vaste activa.</li>-->
<!--</ul>-->

<!--<b>LANGLOPENDE VORDERINGEN GROEPSMAATSCHAPPIJEN</b>-->
<!--<p>Vermeld de langlopende hypothecaire of andere vorderingen op groepsmaatschappijen.-->
<!--    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale resultatenenrekening bij 'Overige opbrengsten' of-->
<!--    'Financiële baten'.-->
<!--    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta of om-->
<!--    (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale resultatenrekening bij-->
<!--    'Financiële baten' of 'Financiële lasten'.</p>-->

<!--<br/>-->
<!--<b>LANGLOPENDE VORDERINGEN PARTICIPANTEN</b>-->
<!--<p>Vermeld de langlopende hypothecaire of andere vorderingen op participanten en maatschappijen waarin wordt-->
<!--    deelgenomen.-->
<!--    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale winst-en-verliesrekening bij 'Overige-->
<!--    opbrengsten' of 'Financiële baten'.-->
<!--    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta of om-->
<!--    (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale resultatenrekening bij-->
<!--    'Financiële baten' of 'Financiële lasten'.</p>-->

<!--<br/>-->
<!--<b>OVERIGE FINANCIELE VASTE ACTIVA</b>-->
<!--<p>Onder 'Overige financiële vaste activa' vallen bijvoorbeeld:</p>-->
<!--<ul>-->
<!--    <li>Binnen- en buitenlandse belangen waarop de deelnemingsvrijstelling niet van toepassing is.</li>-->
<!--    <li>Langlopende vorderingen op derden.</li>-->
<!--</ul>-->
<!--Opbrengsten uit deze vorderingen vermeld je op de fiscale winst-en-verliesrekening bij Overige-->
<!--opbrengsten' of 'Financiële baten'.-->
<!--<br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta of om-->
<!--(gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale resultatenrekening bij-->
<!--'Financiële baten' of 'Financiële lasten'.-->

<!--<br/><br/>-->
<!--<b>DEELNEMING</b>-->
<!--<p>Winsten en verliezen uit een deelneming maken in het algemeen geen deel uit van de belastbare winst-->
<!--    (deelnemingsvrijstelling). Met de deelnemingsvrijstelling voorkom je dat winst die al eerder is belast bij een-->
<!--    dochtermaatschappij, nog een keer wordt belast bij de moedermaatschappij.</p>-->
<!--<p>Bij winsten gaat het bijvoorbeeld om ontvangen dividend en om winst bij verkoop van een deelneming. Bij verliezen-->
<!--    gaat het bijvoorbeeld om verlies bij verkoop van een deelneming. De winsten zijn in dit geval niet belast. De-->
<!--    verliezen zijn niet aftrekbaar. Aan- en verkoopkosten van een deelneming zijn niet aftrekbaar.</p>-->
<!--<p>Er is sprake van een deelneming in de volgende gevallen:</p>-->
<!--<ul style="list-style: disc;">-->
<!--    <li>De vennootschap bent voor ten minste 5% van het nominaal gestorte kapitaal aandeelhouder van een vennootschap-->
<!--        waarvan het kapitaal geheel of gedeeltelijk in aandelen is verdeeld (bijvoorbeeld een naamloze of besloten-->
<!--        vennootschap).-->
<!--    </li>-->
<!--    <li>De vennootschap bezit ten minste 5% van het aantal bewijzen van deelgerechtigdheid dat in omloop is in een fonds-->
<!--        voor gemene rekening.-->
<!--    </li>-->
<!--    <li>De vennootschap is lid van een coöperatie of van een vereniging op coöperatieve grondslag.</li>-->
<!--    <li>De vennootschap neemt als commanditair vennoot voor ten minste 5% deel in een open commanditaire vennootschap.-->
<!--    </li>-->
<!--    <li>De vennootschap bezit aandelen die een stemrecht van ten minste 5% vertegenwoordigen in een vennootschap die in-->
<!--        een EU-lidstaat is gevestigd. Voorwaarde hierbij is dat met deze lidstaat een verdrag ter voorkoming van dubbele-->
<!--        belasting is gesloten dat voorziet in een verlaging van belastingheffing op dividenden op grond van het aantal-->
<!--        stemrechten.-->
<!--    </li>-->
<!--    <li>De vennootschap heeft een deelneming door gelijkstelling (meesleepregeling).</li>-->
<!--    <li>U hebt een deelneming door de meetrekregeling.</li>-->
<!--</ul>-->
<!--<p>Een aandelenbezit van minder dan 5% kan geen deelneming vormen. Er is 1 uitzondering: Als een deelneming van ten-->
<!--    minste 5% na een bezit van meer dan 1 jaar daalt onder het 5%-niveau, dan is de deelnemingsvrijstelling nog 3 jaar-->
<!--    van toepassing. Voor buitenlandse belangen geldt dat er ook sprake kan zijn van een deelneming als je aandelen bezit-->
<!--    die een stemrecht van ten minste 5% vertegenwoordigen in een vennootschap die in een andere EU-lidstaat is-->
<!--    gevestigd.</p>-->

<!--<b>Deelneming door gelijkstelling (meesleepregeling)</b>-->
<!--<p>Als je een deelneming hebt in een vennootschap en in die vennootschap ook deelneemt door het bezitten van-->
<!--    winstbewijzen, worden ook de winstbewijzen als deelneming beschouwd. Dit geldt niet als je een deelneming-->
<!--    uitsluitend bezit op grond van de meetrekregeling.</p>-->
<!--<p>Ook als deelneming wordt beschouwd een hybride lening aan een vennootschap waarin jeeen deelneming bezit. Ook dit-->
<!--    geldt niet als je een deelneming uitsluitend bezit op grond van de meetrekregeling.-->
<!--</p>-->
<!--<b>Meetrekregeling deelneming</b>-->
<!--<p>Je hebt ook een deelneming in de volgende gevallen:</p>-->
<!--<ul>-->
<!--    <li>De vennootschap is aandeelhouder in een met u verbonden lichaam in de zin van artikel 10a, lid 4 Vpb.</li>-->
<!--    <li>De vennootschap is aandeelhouder in een vennootschap waarin een met de vennootschap verbonden lichaam een-->
<!--        deelneming heeft.-->
<!--    </li>-->
<!--    <li>De vennootschap heeft een hybride lening verstrekt aan een vennootschap, en een met de vennootschap verbonden-->
<!--        lichaam heeft een deelneming in-->
<!--        die vennootschap.-->
<!--    </li>-->
<!--    <li>De vennootschap heeft een hybride lening verstrekt aan een met de vennnootschap verbonden vennootschap.</li>-->
<!--    <li>De vennootschap heeft een winstbewijs van een vennootschap waarin een met de vennnootschap verbonden lichaam een-->
<!--        deelneming heeft.-->
<!--    </li>-->
<!--    <li>De vennootschap heeft een winstbewijs van een met de vennnootschap verbonden lichaam.-->
<!--    </li>-->
<!--</ul>-->

<!--<b>Hybride leningen</b>-->
<!--<p>Bedoeld zijn leningen die feitelijk functioneren als eigen vermogen in de zin van artikel 10, lid 1d Vpb. Of er-->
<!--    sprake is van een hybride lening, hangt af van de voorwaarden die zijn overeengekomen. Deze voorwaarden moeten de-->
<!--    lening het karakter van eigen vermogen geven.-->
<!--    <br/>Bij hybride leningen moet worden vastgesteld of er in fiscale zin sprake is van eigen vermogen of van vreemd-->
<!--    vermogen. In de wet was daarvoor een nadere invulling gegeven. Deze is sinds 2007 vervallen. Bij het beantwoorden-->
<!--    van de vraag of de lening vreemd vermogen of eigen vermogen is, wordt nu uitsluitend gekeken naar de-->
<!--    jurisprudentie.-->
<!--    <br/>De Hoge Raad heeft voor de afbakening tussen normale leningen en hybride leningen in het verleden criteria-->
<!--    ontwikkeld. Deze criteria zijn terug te vinden in het arrest van 5 juni 1957, nr. 13 127 en het arrest van 11 maart-->
<!--    1998, nr. 32 240.Volgens deze arresten is sprake van een hybride lening als aan alle volgende voorwaarden is-->
<!--    voldaan:</p>-->
<!--<ul>-->
<!--    <li>De vergoeding voor de geldverstrekking is afhankelijk van de winst.</li>-->
<!--    <li>De schuld is achtergesteld bij alle concurrente schuldeisers.</li>-->
<!--    <li>De schuld heeft geen vaste looptijd maar is alleen opeisbaar bij faillissement, surséance van betaling of-->
<!--        liquidatie.-->
<!--    </li>-->
<!--</ul>-->
<!--<p>De rente op een hybride lening is bij de schuldenaar niet aftrekbaar van de winst. Een afwaardering van de lening-->
<!--    leidt bij de schuldeiser ook niet tot een aftrekbaar verlies. Het weer opwaarderen van een afgewaardeerde hybride-->
<!--    vordering leidt niet tot winst.</p>-->

<!--<b>Hybride leningen en dividendbelasting</b>-->
<!--<p>Over de rente op hybride leningen moet de schuldenaar dividendbelasting inhouden en afdragen.</p>-->

<!--<b>Hybride leningen en deelnemingsvrijstelling (meesleepregeling)</b>-->
<!--<p>Als de vennootschap een hybride lening verstrekt aan een vennootschap waarin de vennootschap een deelneming hebt,-->
<!--    wordt ook de hybride lening als-->
<!--    deelneming beschouwd. Dat wil zeggen dat de deelnemingsvrijstelling van toepassing is op de ontvangen rente, maar-->
<!--    ook op waardemutaties in de vordering.</p>-->

<!--<br/>-->
<!--<b>VOORRADEN</b>-->
<!--<p>Onder 'Voorraden' vallen bijvoorbeeld:</p>-->
<!--<ul>-->
<!--    <li>Grond- en hulpstoffen.</li>-->
<!--    <li>Gereed product en handelsgoederen.</li>-->
<!--    <li>Vooruitbetaling op voorraden.</li>-->
<!--    <li>agrarische voorraden.</li>-->
<!--</ul>-->


<!--<b>Onderhanden werk</b>-->
<!--<p>Bij onderhanden werk gaat het om langlopende projecten en opdrachten zoals een bouwwerk waaraan langere tijd wordt-->
<!--    gewerkt.-->
<!--    <br/>In de kostprijs neem je alle direct toerekenbare kosten mee, zoals lonen, materialen, kosten en afschrijving-->
<!--    van gebruikte machines, energie en werk door derden. Het zogenoemde constante deel van de algemene kosten, zoals-->
<!--    loonkosten van de algemene leiding en huisvestingskosten, moet ook worden geactiveerd.-->
<!--    <br/>De winst moet voortschrijdend worden genomen. Je mag dus niet wachten met winstneming tot het werk of de-->
<!--    opdracht is-->
<!--    afgerond. Als een opdracht voor de helft klaar is, dan moet je de helft van de overeengekomen prijs op dat moment-->
<!--    dus activeren. Dit activeren leidt vervolgens tot winstneming.-->
<!--</p>-->

<!--<br/>-->
<!--<b>DEBITEUREN</b>-->
<!--<p>Vermeld ook de gewone handelsvorderingen op gelieerde maatschappijen en op aandeelhouders, als ze te maken hebben met-->
<!--    de normale omzet van het bedrijf.-->
<!--</p>-->

<!--<br/>-->
<!--<b>OMZETBELASTING</b>-->
<!--<p>Het gaat om de vordering van aangiften omzetbelasting die op de balansdatum nog niet zijn verwerkt, zoals de laatst-->
<!--    ingediende maand- of kwartaalaangifte. Het gaat ook om vorderingen over oudere boekjaren.-->
<!--</p>-->

<!--<br/>-->
<!--<b>KORTLOPENDE VORDERINGEN GROEPSMAATSCHAPPIJEN / PARTICIPANTEN</b>-->
<!--<p>Vermeld de kortlopende vorderingen op participanten en maatschappijen waarin wordt deelgenomen.-->
<!--    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale resultatenenrekening bij 'Overige opbrengsten' of-->
<!--    'Financiële baten'.-->
<!--    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta of om-->
<!--    (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale resultatenrekening bij-->
<!--    'Financiële baten' of 'Financiële lasten'.-->
<!--</p>-->

<!--<br/>-->
<!--<b>OVERIGE KORTLOPENDE VORDERINGEN</b>-->
<!--<p>Onder 'Overige vorderingen' vallen bijvoorbeeld:</p>-->
<!--<ul>-->
<!--    <li>Vorderingen vennootschapsbelasting.</li>-->
<!--    <li> overlopende activa. Overlopende activa zijn onder meer vooruitbetalingen van voorschotten en uitgaven die in-->
<!--        het verleden zijn gedaan en die aan toekomstige jaren moeten worden toegerekend. .-->
<!--    </li>-->
<!--</ul>-->

<!--<b>EFFECTEN</b>-->
<!--<p>Onder 'Effecten' vallen zowel tijdelijke beleggingen als effectenportefeuilles voor de lange termijn.</p>-->

<!--<br/>-->
<!--<b>LIQUIDE MIDDELEN</b>-->
<!--<p>Liquide middelen zijn geldmiddelen die beschikbaar zijn in de onderneming. Dit is de zakelijke bankrekening, de-->
<!--    kas, de creditcard rekening, maar ook rekeningen van betaalproviders zoals Mollie, Paypal, etc. Onder 'Liquide-->
<!--    middelen' vallen ook:</p>-->
<!--<ul>-->
<!--    <li>Contant geld.</li>-->
<!--    <li>Verhandelbare 'instrumenten' aan toonder, zoals (reis)cheques, promessen of betalingsopdrachten aan toonder.-->
<!--    </li>-->
<!--    <li>Waardedragers, zoals munten met een goudgehalte van 90% of meer en ongemunt goud met een goudgehalte van-->
<!--        minimaal 99,5%-->
<!--    </li>-->
<!--</ul>-->


<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Goodwill
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Goodwill is de meerwaarde van een onderneming boven de balanswaarde. Het vertegenwoordigt
                    toekomstige inkomsten van de onderneming die nog niet zijn gewaardeerd op de balans, maar die al wel
                    bestaan. Voorbeelden hiervan zijn klantenkring, naamsbekendheid en personeel. Goodwill die je
                    overneemt, vormt een bedrijfsmiddel waarop kan worden afgeschreven. Het afschrijvingspercentage op
                    goodwill is maximaal 10%.
                    <br/><br/>
                    Vermeld hier niet de goodwill die is meegekocht bij de aankoop van deelnemingen. Op die goodwill kun
                    je niet afschrijven.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Overige immateriele vaste activa
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Overig immateriële vaste activa' vallen bijvoorbeeld:</p>
                <ul>
                    <li>Notariële kosten en andere oprichtings- en emissiekosten.<br>
                        Notariële kosten en andere oprichtings- en emissiekosten zijn bijvoorbeeld notariskosten voor de
                        oprichtingsakte en kosten die u maakt bij het uitgeven van nieuwe aandelen (emissiekosten).
                    </li>
                    <li>Kosten van onderzoek en ontwikkeling.<br>
                        Je kunt kosten van onderzoek en ontwikkeling alleen activeren en vervolgens afschrijven, als het
                        gaat om het ontwikkelen van concrete technologieën en producten.
                    </li>
                    <li>Vergunningen, concessies en intellectuele eigendommen.</li>
                    <li>Vooruitbetaling op immateriële vaste activa.</li>
                    <li>Productierechten (voor agrariërs).</li>
                </ul>

                <b>Vergunningen, concessies en intellectuele eigendommen</b>
                <p>Voorbeelden van vergunningen en concessies zijn:</p>
                <ul>
                    <li>Vervoersvergunningen</li>
                    <li>Vangstquota</li>
                    <li>Octrooien</li>
                    <li>Patenten</li>
                    <li>Auteursrechten</li>
                </ul>
                <p>Vergunningen, concessies en intellectuele eigendommen moeten worden geboekt voor de kostprijs of voor
                    een lagere bedrijfswaarde. De uitgaven voor vergunningen, concessies en dergelijke moet je door
                    afschrijving toerekenen aan de jaren waarin ze zullen worden benut. Bij de afschrijving moet je
                    rekening houden met de restwaarde. Als je voor de instandhouding van de vergunningen, concessies en
                    intellectuele eigendommen periodiek, bijvoorbeeld jaarlijks, betalingen moet doen, dan mag je deze
                    in het jaar van betaling ineens ten laste van de winst brengen.</p>

                <b>Productierechten voor agrariërs</b>
                <p>Productierechten zijn verhandelbare rechten voor landbouwers om te mogen produceren. De
                    productierechten zijn meestal gebaseerd op een uitwerking van het landbouwbeleid van de Europese
                    Unie. Je kunt de kosten van productierechten afschrijven volgens de daarvoor afgesproken regelingen.
                    Zie <a
                            href="https://www.belastingdienst.nl/data/online_aangifte/vpb/vpb2023/meer_info/afschrijving_productierechten.htm"
                            target="_blank">Afschrijving productierechten</a> voor meer informatie hierover.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Gebouwen en terreinen
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Voor het bepalen van de fiscale winst is de normale jaarlijkse afschrijving op gebouwen beperkt. Deze
                    beperking houdt in dat de boekwaarde van een gebouw niet lager mag zijn dan de bodemwaarde. Het
                    begrip bodemwaarde is een fiscaal begrip. Het heeft niets te maken met de waarde van de grond. Het
                    is ook niet hetzelfde als de restwaarde. Voor alle bedrijfsgebouwen geldt een bodemwaarde van 100%
                    van de WOZ-waarde.</p>
                <b>Milieubedrijfsmiddelen en bodemwaarde</b>
                <p>De boekwaarde van een gebouw dat een milieubedrijfsmiddel is en dat u op of na 1 januari 2009 hebt
                    gekocht, mag lager zijn dan de bodemwaarde. Als je in het kalenderjaar 2007 of 2008 onroerende zaken
                    hebt aangeschaft die een milieubedrijfsmiddel zijn, moet je (ook in latere jaren) rekening blijven
                    houden met de bodemwaarde.</p>
                <b>Bedrijfsterreinen</b>
                <p>Omdat grond en (bedrijfs)terreinen niet slijten, kun je daarop niet afschrijven. Wel kun je
                    afschrijven op
                    verbeteringen aan de (bedrijfs)terreinen zoals erfverhardingen, drainage, damwanden e.d.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Andere vaste activa
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Andere materiële vaste activa' vallen bijvoorbeeld:</p>
                <ul>
                    <li>inventaris.</li>
                    <li>auto's en overige transportmiddelen.</li>
                    <li>vooruitbetaling op materiële vaste activa.</li>
                    <li>agrarische materiële vaste activa.</li>
                </ul>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Langlopende vorderingen gropesmaatschappijen
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld de langlopende hypothecaire of andere vorderingen op groepsmaatschappijen.
                    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale resultatenenrekening bij 'Overige
                    opbrengsten' of 'Financiële baten'.
                    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta
                    of om (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale
                    resultatenrekening bij 'Financiële baten' of 'Financiële lasten'.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Langlopende vorderingen participanten
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div>
                <p>Vermeld de langlopende hypothecaire of andere vorderingen op participanten en maatschappijen waarin
                    wordt deelgenomen.
                    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale winst-en-verliesrekening bij 'Overige
                    opbrengsten' of 'Financiële baten'.
                    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta
                    of om (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale
                    resultatenrekening bij 'Financiële baten' of 'Financiële lasten'.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Overige financiele vaste activa
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Overige financiële vaste activa' vallen bijvoorbeeld:</p>
                <ul>
                    <li>Binnen- en buitenlandse belangen waarop de deelnemingsvrijstelling niet van toepassing is.</li>
                    <li>Langlopende vorderingen op derden.</li>
                </ul>
                Opbrengsten uit deze vorderingen vermeld je op de fiscale winst-en-verliesrekening bij Overige
                opbrengsten' of 'Financiële baten'.
                <br/>
                <p>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta of om
                    (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale
                    resultatenrekening bij 'Financiële baten' of 'Financiële lasten'.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Deelneming
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Winsten en verliezen uit een deelneming maken in het algemeen geen deel uit van de belastbare winst
                    (deelnemingsvrijstelling). Met de deelnemingsvrijstelling voorkom je dat winst die al eerder is
                    belast bij een
                    dochtermaatschappij, nog een keer wordt belast bij de moedermaatschappij.</p>
                <p>Bij winsten gaat het bijvoorbeeld om ontvangen dividend en om winst bij verkoop van een deelneming.
                    Bij verliezen gaat het bijvoorbeeld om verlies bij verkoop van een deelneming. De winsten zijn in
                    dit geval niet belast. De verliezen zijn niet aftrekbaar. Aan- en verkoopkosten van een deelneming
                    zijn niet aftrekbaar.</p>
                <p>Er is sprake van een deelneming in de volgende gevallen:</p>
                <ul style="list-style: disc;">
                    <li>De vennootschap bent voor ten minste 5% van het nominaal gestorte kapitaal aandeelhouder van een
                        vennootschap
                        waarvan het kapitaal geheel of gedeeltelijk in aandelen is verdeeld (bijvoorbeeld een naamloze
                        of besloten vennootschap).
                    </li>
                    <li>De vennootschap bezit ten minste 5% van het aantal bewijzen van deelgerechtigdheid dat in omloop
                        is in een fonds voor gemene rekening.
                    </li>
                    <li>De vennootschap is lid van een coöperatie of van een vereniging op coöperatieve grondslag.</li>
                    <li>De vennootschap neemt als commanditair vennoot voor ten minste 5% deel in een open commanditaire
                        vennootschap.
                    </li>
                    <li>De vennootschap bezit aandelen die een stemrecht van ten minste 5% vertegenwoordigen in een
                        vennootschap die in een EU-lidstaat is gevestigd. Voorwaarde hierbij is dat met deze lidstaat
                        een verdrag ter voorkoming van dubbele belasting is gesloten dat voorziet in een verlaging van
                        belastingheffing op dividenden op grond van het aantal stemrechten.
                    </li>
                    <li>De vennootschap heeft een deelneming door gelijkstelling (meesleepregeling).</li>
                    <li>U hebt een deelneming door de meetrekregeling.</li>
                </ul>
                <p>Een aandelenbezit van minder dan 5% kan geen deelneming vormen. Er is 1 uitzondering: Als een
                    deelneming van ten minste 5% na een bezit van meer dan 1 jaar daalt onder het 5%-niveau, dan is de
                    deelnemingsvrijstelling nog 3 jaar
                    van toepassing. Voor buitenlandse belangen geldt dat er ook sprake kan zijn van een deelneming als
                    je aandelen bezit die een stemrecht van ten minste 5% vertegenwoordigen in een vennootschap die in
                    een andereEU-lidstaat is
                    gevestigd.</p>

                <b>Deelneming door gelijkstelling (meesleepregeling)</b>
                <p>Als je een deelneming hebt in een vennootschap en in die vennootschap ook deelneemt door het bezitten
                    van winstbewijzen, worden ook de winstbewijzen als deelneming beschouwd. Dit geldt niet als je een
                    deelneming uitsluitend bezit op grond van de meetrekregeling.</p>
                <p>Ook als deelneming wordt beschouwd een hybride lening aan een vennootschap waarin jeeen deelneming
                    bezit. Ook dit geldt niet als je een deelneming uitsluitend bezit op grond van de meetrekregeling.
                </p>
                <b>Meetrekregeling deelneming</b>
                <p>Je hebt ook een deelneming in de volgende gevallen:</p>
                <ul>
                    <li>De vennootschap is aandeelhouder in een met u verbonden lichaam in de zin van artikel 10a, lid 4
                        Vpb.
                    </li>
                    <li>De vennootschap is aandeelhouder in een vennootschap waarin een met de vennootschap verbonden
                        lichaam een deelneming heeft.
                    </li>
                    <li>De vennootschap heeft een hybride lening verstrekt aan een vennootschap, en een met de
                        vennootschap verbonden lichaam heeft een deelneming in die vennootschap.
                    </li>
                    <li>De vennootschap heeft een hybride lening verstrekt aan een met de vennnootschap verbonden
                        vennootschap.
                    </li>
                    <li>De vennootschap heeft een winstbewijs van een vennootschap waarin een met de vennnootschap
                        verbonden lichaam een deelneming heeft.
                    </li>
                    <li>De vennootschap heeft een winstbewijs van een met de vennnootschap verbonden lichaam.
                    </li>
                </ul>

                <b>Hybride leningen</b>
                <p>Bedoeld zijn leningen die feitelijk functioneren als eigen vermogen in de zin van artikel 10, lid 1d
                    Vpb. Of er sprake is van een hybride lening, hangt af van de voorwaarden die zijn overeengekomen.
                    Deze voorwaarden moeten de lening het karakter van eigen vermogen geven.
                    <br/>Bij hybride leningen moet worden vastgesteld of er in fiscale zin sprake is van eigen vermogen
                    of van vreemd vermogen. In de wet was daarvoor een nadere invulling gegeven. Deze is sinds 2007
                    vervallen. Bij het beantwoorden van de vraag of de lening vreemd vermogen of eigen vermogen is,
                    wordt nu uitsluitend gekeken naar de jurisprudentie.
                    <br/>De Hoge Raad heeft voor de afbakening tussen normale leningen en hybride leningen in het
                    verleden criteria ontwikkeld. Deze criteria zijn terug te vinden in het arrest van 5 juni 1957, nr.
                    13 127 en het arrest van 11 maart 1998, nr. 32 240.Volgens deze arresten is sprake van een hybride
                    lening als aan alle volgende voorwaarden is voldaan:</p>
                <ul>
                    <li>De vergoeding voor de geldverstrekking is afhankelijk van de winst.</li>
                    <li>De schuld is achtergesteld bij alle concurrente schuldeisers.</li>
                    <li>De schuld heeft geen vaste looptijd maar is alleen opeisbaar bij faillissement, surséance van
                        betaling of liquidatie.
                    </li>
                </ul>
                <p>De rente op een hybride lening is bij de schuldenaar niet aftrekbaar van de winst. Een afwaardering
                    van de lening leidt bij de schuldeiser ook niet tot een aftrekbaar verlies. Het weer opwaarderen van
                    een afgewaardeerde hybride vordering leidt niet tot winst.</p>

                <b>Hybride leningen en dividendbelasting</b>
                <p>Over de rente op hybride leningen moet de schuldenaar dividendbelasting inhouden en afdragen.</p>

                <b>Hybride leningen en deelnemingsvrijstelling (meesleepregeling)</b>
                <p>Als de vennootschap een hybride lening verstrekt aan een vennootschap waarin de vennootschap een
                    deelneming hebt, wordt ook de hybride lening als deelneming beschouwd. Dat wil zeggen dat de
                    deelnemingsvrijstelling van toepassing is op de ontvangen rente, maar ook op waardemutaties in de
                    vordering.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Voorraden
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Voorraden' vallen bijvoorbeeld:</p>
                <ul>
                    <li>Grond- en hulpstoffen.</li>
                    <li>Gereed product en handelsgoederen.</li>
                    <li>Vooruitbetaling op voorraden.</li>
                    <li>agrarische voorraden.</li>
                </ul>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Onderhanden werk
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Bij onderhanden werk gaat het om langlopende projecten en opdrachten zoals een bouwwerk waaraan
                    langere tijd wordt gewerkt.
                    <br/>In de kostprijs neem je alle direct toerekenbare kosten mee, zoals lonen, materialen, kosten en
                    afschrijving van gebruikte machines, energie en werk door derden. Het zogenoemde constante deel van
                    de algemene kosten, zoals loonkosten van de algemene leiding en huisvestingskosten, moet ook worden
                    geactiveerd.
                    <br/>De winst moet voortschrijdend worden genomen. Je mag dus niet wachten met winstneming tot het
                    werk of de opdracht is afgerond. Als een opdracht voor de helft klaar is, dan moet je de helft van
                    de overeengekomen prijs op dat moment dus activeren. Dit activeren leidt vervolgens tot winstneming.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse11">
                Debiteuren
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld ook de gewone handelsvorderingen op gelieerde maatschappijen en op aandeelhouders, als ze te
                    maken hebben met de normale omzet van het bedrijf.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Omzetbelasting
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het gaat om de vordering van aangiften omzetbelasting die op de balansdatum nog niet zijn verwerkt,
                    zoals de laatst ingediende maand- of kwartaalaangifte. Het gaat ook om vorderingen over oudere
                    boekjaren.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                Kortlopende vorderingen groepsmaatschappijen
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld de kortlopende vorderingen op participanten en maatschappijen waarin wordt deelgenomen.
                    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale resultatenenrekening bij 'Overige
                    opbrengsten' of 'Financiële baten'.
                    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta
                    of om
                    (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale
                    resultatenrekening bij 'Financiële baten' of 'Financiële lasten'.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading14">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse14" aria-expanded="false" aria-controls="collapse14">
                Kortlopende vorderingen participanten
            </button>
        </h2>
        <div id="collapse14" class="accordion-collapse collapse" aria-labelledby="heading14"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld de kortlopende hypothecaire of andere vorderingen op participanten en maatschappijen waarin
                    wordt deelgenomen.
                    <br/>Opbrengsten uit deze vorderingen vermeld je op de fiscale winst-en-verliesrekening bij 'Overige
                    opbrengsten' of 'Financiële baten'.
                    <br/>De boekwaarde kan afwijken van de nominale waarde als het gaat om vorderingen in vreemde valuta
                    of om (gedeeltelijk) niet-inbare vorderingen. Afwijkingen in de boekwaarde vermeld je op de fiscale
                    resultatenrekening bij 'Financiële baten' of 'Financiële lasten'.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading15">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse15" aria-expanded="false" aria-controls="collapse15">
                Overige kortlopende vorderingen
            </button>
        </h2>
        <div id="collapse15" class="accordion-collapse collapse" aria-labelledby="heading15"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Overige kortlopende vorderingen' vallen bijvoorbeeld:</p>
                <ul>
                    <li>Vorderingen vennootschapsbelasting.</li>
                    <li> overlopende activa. Overlopende activa zijn onder meer vooruitbetalingen van voorschotten en
                        uitgaven die in het verleden zijn gedaan en die aan toekomstige jaren moeten worden toegerekend.
                        .
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading16">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse16" aria-expanded="false" aria-controls="collapse16">
                Effecten
            </button>
        </h2>
        <div id="collapse16" class="accordion-collapse collapse" aria-labelledby="heading16"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Effecten' vallen zowel tijdelijke beleggingen als effectenportefeuilles voor de lange
                    termijn.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading17">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse17" aria-expanded="false" aria-controls="collapse17">
                Liquide middelen
            </button>
        </h2>
        <div id="collapse17" class="accordion-collapse collapse" aria-labelledby="heading17"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Liquide middelen zijn geldmiddelen die beschikbaar zijn in de onderneming. Dit is de zakelijke
                    bankrekening, de kas, de creditcard rekening, maar ook rekeningen van betaalproviders zoals Mollie,
                    Paypal, etc. Onder 'Liquide middelen' vallen ook:</p>
                <ul>
                    <li>Contant geld.</li>
                    <li>Verhandelbare 'instrumenten' aan toonder, zoals (reis)cheques, promessen of betalingsopdrachten
                        aan toonder.
                    </li>
                    <li>Waardedragers, zoals munten met een goudgehalte van 90% of meer en ongemunt goud met een
                        goudgehalte van minimaal 99,5%
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>





